import { useFormik } from "formik";
import companyValidationSchema from "@companies/schemas/companyValidationSchema";
import type { UseCompanyFormProps} from "./types";
import type { CompanyValues } from "@companies/types/company";

const useCompanyForm = ({
    company, 
    isOpen, 
    onClose,
    onCreateCompany,
    onUpdateCompany
}: UseCompanyFormProps) => {
    
    const {
        errors, 
        values, 
        touched, 
        handleSubmit, 
        handleReset,
        handleChange, 
        setFieldValue
    } = useFormik<CompanyValues>({
        initialValues:{
            nombre: company?.nombre ?? '',
        },
        onSubmit: async (values, {resetForm}) => {
            if(company){
                if(await onUpdateCompany(company.id, values)){
                    resetForm()
                    if(isOpen) onClose()
                }
            } else {
                if(await onCreateCompany(values)){
                    resetForm()
                    if(isOpen) onClose()
                }
            }
        },
        enableReinitialize: true,
        validationSchema: companyValidationSchema
    })

    return {
        values,
        errors,
        touched,
        handleChange,
        handleReset,
        handleSubmit,
        setFieldValue
    }

}

export default useCompanyForm;